import { useEffect } from 'react';
import { useAlgoliaDataContext } from '../hooks/useAlgoliaDataContext';
import { algoliaViewHit } from '../events/algolia.viewHit';
import { defaultSearchParams, nbItemsPerPage, sortConfigByNameOrIndex } from '../configs';
import { SEARCH_PARAM_KEY_PAGE_NUMBER, SEARCH_PARAM_KEY_SORT } from '../constants/searchParamKeys';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDynamicConfigs } from '../hooks/useDynamicConfigs';
export const DLViewHit = () => {
    const [searchParams] = useSearchParams();
    const { collection } = useDynamicConfigs();
    const { handle } = useParams();
    const { hits, queryID } = useAlgoliaDataContext();
    const sortConfig = sortConfigByNameOrIndex[searchParams.get(SEARCH_PARAM_KEY_SORT) ?? defaultSearchParams.index];
    const sortIndex = sortConfig?.index ?? defaultSearchParams.index;
    const hitsPerPage = (collection?.capsuleItems !== undefined && collection.capsuleItems.length > 1) ||
        handle === 'photo-prints'
        ? nbItemsPerPage + 1
        : nbItemsPerPage;
    useEffect(() => {
        algoliaViewHit(sortIndex, queryID, hits, hitsPerPage * (+(searchParams.get(SEARCH_PARAM_KEY_PAGE_NUMBER) ?? 1) - 1) + 1);
    }, [queryID]);
    return null;
};
